import dayjs, { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import { TableReservationSimpleFilter } from '@client/page/management/table-reservation/list/component/table-reservation-simple-filter.tsx';
import { useSearchParams } from 'react-router-dom';
import { TableReservationPaginationFooter } from '@client/page/management/table-reservation/list/component/table-reservation-pagination-footer.tsx';
import { ContentLayout, PrimaryContent } from '@packages/ui/content-layout.tsx';
import InvoiceList from '@client/page/management/invoice/invoice-list/invoice-list.tsx';

const InvoiceListPage = () => {
  const [params, setParams] = useSearchParams();
  const startTime = dayjs(params.get('startTime') ?? dayjs().toISOString()).startOf('day');
  const endTime = dayjs(params.get('endTime') ?? dayjs().toISOString()).endOf('day');

  const setTime = useCallback(
    (start: Dayjs, end: Dayjs) => {
      params.set('startTime', start.toISOString());
      params.set('endTime', end.toISOString());
      setParams(params);
    },
    [params, setParams]
  );

  return (
    <ContentLayout>
      <PrimaryContent>
        <InvoiceList
          startTime={startTime}
          endTime={endTime}
          header={
            <>
              <TableReservationSimpleFilter
                startTime={startTime}
                endTime={endTime}
                onChange={(data) => {
                  setTime(data[0], data[1]);
                }}
              />
            </>
          }
          footer={
            <TableReservationPaginationFooter
              startTime={startTime}
              endTime={endTime}
              onChange={(data) => {
                setTime(data[0], data[1]);
              }}
            />
          }
        />
      </PrimaryContent>
    </ContentLayout>
  );
};

export default InvoiceListPage;
